import { TimeSlot, TimeSlots } from '@checkout/const';
import { Action } from '@ngrx/store';
import { StateUtils } from '@spartacus/core';
import { TIME_SLOTS } from '../checkout-state';

export const LOAD_TIME_SLOTS = '[Checkout] Load timeslots';
export const LOAD_TIME_SLOTS_FAIL = '[Checkout] Load timeslots Fail';
export const LOAD_TIME_SLOTS_SUCCESS = '[Checkout] Load timeslots Success';
export const LOAD_TIME_SLOTS_RESET = '[Checkout] timeslots Reset';

export const SET_TIME_SLOTS = '[Checkout] Set timeslot';
export const RESET_TIME_SLOTS = '[Checkout] Reset timeslot';
export const MANAGER_WILL_CLARIFY = '[Checkout] manager will clarify';

export class LoadTimeSlots extends StateUtils.LoaderLoadAction {
  readonly type = LOAD_TIME_SLOTS;

  constructor(public payload: { polygonId: string }) {
    super(TIME_SLOTS);
  }
}

export class LoadTimeSlotsFail extends StateUtils.LoaderFailAction {
  readonly type = LOAD_TIME_SLOTS_FAIL;

  constructor(public payload: any) {
    super(TIME_SLOTS, payload);
  }
}

export class LoadTimeSlotsSuccess extends StateUtils.LoaderSuccessAction {
  readonly type = LOAD_TIME_SLOTS_SUCCESS;

  constructor(public payload: TimeSlots) {
    super(TIME_SLOTS);
  }
}

export class SetTimeSlotsMode implements Action {
  readonly type = SET_TIME_SLOTS;

  constructor(public payload?: TimeSlot) {}
}

export class ResetTimeSlotsMode implements Action {
  readonly type = RESET_TIME_SLOTS;
}

export class TimeSlotsReset extends StateUtils.LoaderResetAction {
  readonly type = LOAD_TIME_SLOTS_RESET;

  constructor() {
    super(TIME_SLOTS);
  }
}

export class SetManagerWillClarify implements Action {
  readonly type = MANAGER_WILL_CLARIFY;
}

export type TimeSlotsActions =
  | LoadTimeSlots
  | LoadTimeSlotsSuccess
  | LoadTimeSlotsFail
  | SetTimeSlotsMode
  | ResetTimeSlotsMode
  | SetManagerWillClarify
  | TimeSlotsReset;
